'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var BakerAppIcon = function BakerAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512"
  }), React__default["default"].createElement("g", {
    id: "baker_app_icon",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, React__default["default"].createElement("g", {
    transform: "translate(-560.000000, -24.000000)",
    id: "baker_logo"
  }, React__default["default"].createElement("g", {
    transform: "translate(560.000000, 24.000000)"
  }, React__default["default"].createElement("rect", {
    id: "background",
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "512",
    height: "512"
  }), React__default["default"].createElement("path", {
    d: "M351.152957,123.046384 C351.152957,123.046384 380.916774,139.808519 382.056903,177.78173 C382.056903,177.78173 385.8602,220.961885 343.946482,240.424394 C343.946482,240.424394 399.954775,258.129721 396.680669,312.554977 C396.680669,312.554977 402.57492,402.722512 289.24611,406 L183.128078,406 L236.679716,352.39304 L259.499503,373.87114 L283.351859,271.902924 L184.263904,299.703433 L204.691572,324.342737 L119.91331,406 L115,406 L115,106 L290.584148,106 L304.411975,106.658943 L229.146261,181.244412 L206.382404,161.079891 L181.161893,262.393471 L280.731714,234.524054 L260.949402,210.565227 L351.152957,123.046384 Z",
    fill: "#C8102E"
  })))));
};

var BakerAppIcon$1 = iconStyles()(BakerAppIcon);

module.exports = BakerAppIcon$1;
